import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';

import {
  GET_ALL_CATEGORIES_LIST_REQUEST,
  GET_ALL_CATEGORIES_LIST_SUCCESS,
  GET_ALL_CATEGORIES_LIST_FAILURE,
  GET_HOME_SUB_HEADER_REQUEST,
  GET_HOME_SUB_HEADER_SUCCESS,
  GET_HOME_SUB_HEADER_FAILURE
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getAllCategoriesList = () => async dispatch => {
  try {
    dispatch({
      type: GET_ALL_CATEGORIES_LIST_REQUEST
    });

    dispatch({
      type: GET_HOME_SUB_HEADER_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/main-page/summary-all`);

    dispatch({
      type: GET_ALL_CATEGORIES_LIST_SUCCESS,
      payload: res.data
    });

    dispatch({
      type: GET_HOME_SUB_HEADER_SUCCESS,
      payload: res.data.all
    });

  } catch (e) {
    dispatch({
      type: GET_ALL_CATEGORIES_LIST_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });

    dispatch({
      type: GET_HOME_SUB_HEADER_FAILURE,
      payload: errorMessage
    });
  }
};
